<div class="state-displayer">
  @if (currentState === undefined || currentState === null) {
    <div class="skeleton-placeholder">
      <app-state-displayer-skeleton-line
        [type]="getType()"
      ></app-state-displayer-skeleton-line>
    </div>
  }
  @if (!hasNotInit) {
    <div
      class="state-data"
      [attr.data-tracking-id]="
        'state-displayer-' + (currentState?.deviceId || 'unknown')
      "
    >
      <div
        class="incident-checkbox-column state-displayer-column"
        (click)="onHandleDevice($event)"
      >
        @if (activeAlert && !listDetailDisplay) {
          <mat-checkbox
            color="primary"
            [checked]="isChecked"
            (click)="$event.stopPropagation()"
            (change)="updateIncidentDevice($event)"
          >
          </mat-checkbox>
        }
      </div>
      <div class="timestamp-column state-displayer-column">
        <div class="value">
          {{ momentTime }}
        </div>
      </div>
      <div class="device-column state-displayer-column">
        <div class="value">
          {{ getDeviceId() }}
        </div>
      </div>
      <div class="container-column state-displayer-column">
        <div class="value">
          {{ getContainerType() }}
        </div>
      </div>
      <div class="status-column state-displayer-column">
        <div class="value">
          <app-state-displayer-status
            [statusDays]="currentState.statusDays"
            [statusDescription]="currentState.statusDescription"
            [statusColor]="currentState.statusColor"
          ></app-state-displayer-status>
        </div>
      </div>
      <div class="radius-column state-displayer-column">
        <div class="value">{{ currentState.confidenceRadiusInMeter }}m</div>
      </div>
      <div
        class="position-column state-displayer-column"
        [class.large-state-column]="listDisplay || listDetailDisplay"
      >
        <div class="value">
          {{ getPosition() }}
        </div>
      </div>
      <div
        class="last-authorized-site-column state-displayer-column"
        [class.large-state-column]="listDisplay || listDetailDisplay"
      >
        <div class="value">
          {{ getLastAuthorizedSite() }}
        </div>
      </div>
      @if (listDisplay || listDetailDisplay) {
        <div
          class="time-last-site-column state-displayer-column"
          [class.large-state-column]="mapDisplay"
        >
          <div class="value">
            {{ getTimeLastAuthorizedSite() }}
          </div>
        </div>
      }
      <div class="labels-column state-displayer-column">
        @if (currentState.tornOff) {
          <app-state-displayer-label
            labelType="torn"
          ></app-state-displayer-label>
        }
        @if (currentState.isIncident) {
          <app-state-displayer-label
            (changeTab)="onChangeTab($event)"
            labelType="incident"
            [deviceId]="currentState.deviceId"
          ></app-state-displayer-label>
        }
        @if (!currentState.tornOff && !currentState.isIncident) {
          <p class="value">-</p>
        }
      </div>
      @if (listDisplay || listDetailDisplay) {
        @if (isAdmin("IBMAdmin")) {
          <div class="seq-number-column state-displayer-column">
            <div class="value">
              {{ getSeqNumber() }}
            </div>
          </div>
        }
        @if (isAdmin("IBMAdmin")) {
          <div class="source-column state-displayer-column">
            <div class="value">
              {{ getSource() }}
            </div>
          </div>
        }
        <div class="battery-column state-displayer-column">
          <svg-icon
            [name]="getBatteryIcon(currentState.batteryLevel)"
            class="battery-level-icon"
          ></svg-icon>
        </div>
        @if (listDisplay || listDetailDisplay) {
          <div class="maps-column state-displayer-column">
            <app-button
              [rounded]="true"
              iconLeft="map"
              size="small"
              data-tracking-id="button-redirect-gmap"
              (clicked)="
                redirectToGmap(
                  currentState.latitudeComputed,
                  currentState.longitudeComputed
                )
              "
            ></app-button>
          </div>
        }
      }
    </div>
  }
</div>
